import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import style from './blackfridaylist.module.scss';
import noVariantEmptyState from '../../../assets/icons/EmptyStates/variant_noactivevariant.svg'
import Button from "../../Button/button";
import Searchbar from "../../productSearchbar/productSearchbar";
import Dropdown from "../../../Components/Dropdown/RealTimeButtonDropDown/DropDown";
import Pagination from "../../pagination/pagination"
import Skeleton from '../../variantList/skeleton'
import OfferCard from './blackfridaylog/blackfridaycard'
import MobilePagination from "../../mobilePagination/mobilePagination"
import TinyDropdown from "../../Dropdown/tinyDropdown/tinyDropdown";
import Toast from '../../Toast/Toast'
import toPersianNumber from '../../../helpers/actions/toPersianNumber'
import { GetBlackFridayYourList, GetBlackFridayCategoryList, GetBlackFridayList, GetBrands, GetSellers, GetproductGroup } from '../../../actions/APIcalls'

const BlackFridayList = (props) => {

    const [offerData, setOfferData] = useState({
        type: props.type ? props.type : 'your-products',
        list: [],
        page: 1,
        productCount: 100,
        totalPages: 10,
        countInPage: 10,
        filters: {
            sellers: [],
            productGroups: [],
            brands: []
        }
    })
    const [skeleton, setSkeleton] = useState(true)
    const [toast, setToast] = useState('')
    const [locationKeys, setLocationKeys] = useState([])
    const history = useHistory()

    // handle back and forward 
    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    // Handle forward event
                    getProductList();
                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    // Handle back event
                    getProductList();
                }
            }
        })
    }, [locationKeys,])
    // end handle back and forward 
    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    useEffect(async () => {
        await getProductList()
        await getFiltersData()
    }, []);

    const getFromUrl = (param) => {
        const defaultParams = {
            productGroup: [],
            brand: [],
            sellers: [],
            countInPage: 10,
            page: 1,
            query: ""
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (param === "seller" || param === "productGroup" || param === "brand") {
                return url.get(param).split("*");
            } else {
                if (url.get(param) === "true" || url.get(param) === "false") {
                    return url.get(param) === "true" ? true : false;
                } else {
                    return url.get(param)
                }
            }
        } else {
            return defaultParams[param];
        }
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getProductList();
    }

    const deleteFromUrl = (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push(window.location.pathname + "?" + url.toString());
        // delete from state
    }

    const getFilters = () => {
        let tmpUrlFilters = {
            productGroup: getFromUrl('productGroup') ? getFromUrl('productGroup') : '',
            brand: getFromUrl('brand') ? getFromUrl('brand') : '',
            sellers: getFromUrl('sellers') ? getFromUrl('sellers') : '',
            countInPage: getFromUrl('countInPage') ? getFromUrl('countInPage') : 10,
            page: getFromUrl('page') ? getFromUrl('page') : 1,
            q: getFromUrl('query')
        }
        Object.keys(tmpUrlFilters).map(key => {
            if (tmpUrlFilters[key] == '') {
                delete tmpUrlFilters[key];
            }
        })
        return tmpUrlFilters
    }

    const urlCheckerForFilters = () => {
        let result = false;
        const defaultParams = getFilters()
        if ((defaultParams.sellers) || (defaultParams.brand) || (defaultParams.productGroup)) {
            result = true
        }
        return result
    }

    const searchHandler = (value) => {
        setToUrl(value, 'query')
    }

    const pageSetter = number => {
        setToUrl(number, 'page')
    }

    const deleteAllFiletrs = async () => {
        // resetFilters()
        props.history.push(window.location.pathname)
        await getProductList()
    }

    const getProductList = async () => {
        setSkeleton(true)
        let type = offerData.type
        let params = {
            page: getFromUrl('page') ? getFromUrl('page') : 1,
            countInPage: getFromUrl('countInPage') ? getFromUrl('countInPage') : 10,
        }
        let optionalFilters = ['brand', 'productGroup', 'sellers', 'query']
        optionalFilters.map(el => {
            if (getFromUrl(el)) {
                params[el] = getFromUrl(el)
            }
        })

        let res;
        switch (type) {
            case 'your-products':
                res = await GetBlackFridayYourList(params)
                break;
            case 'category-products':
                res = await GetBlackFridayCategoryList(params)
                break;
            case 'all-products':
                res = await GetBlackFridayList(params)
                break;
            default:
                res = await GetBlackFridayList(params)
                break;
        }

        if (res && res.data) {
            let tmp = offerData
            tmp.list = res.data.list
            tmp.totalPages = res.data.pageCount
            tmp.productCount = res.data.totalCount
            setOfferData({ ...tmp })
        }
        setSkeleton(false)
    }

    const getFiltersData = async () => {
        const resBrands = await GetBrands(openToast);
        const resChannels = await GetSellers(openToast);
        const resGroupProduct = await GetproductGroup(openToast);
        let tmp = offerData
        tmp.filters.brands = resBrands && resBrands.data ? urlChecker(resBrands.data.BrandList, "brand") : []
        tmp.filters.productGroups = resGroupProduct && resGroupProduct.data ? urlChecker(resGroupProduct.data.GroupList, "productGroup") : []
        tmp.filters.sellers = resChannels && resChannels.data ? urlChecker(resChannels.data.channelList, "sellers") : []
        setOfferData({ ...tmp })
    }

    const urlChecker = (list, key) => {
        let tempList = [];
        let filters = getFromUrl(key);
        switch (key) {
            case "sellers":
                list.map(item => {
                    if (filters.indexOf(item._id ? item._id : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: false });
                    }
                })
                break;
            case "brand":
                list.map(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            case "productGroup":
                list.map(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            default:
                break;
        }
        return tempList;
    }

    const openToast = (error) => {
        setToast(error)
    }

    const selectHandler = (tag, value) => {
        let tmp = offerData
        tmp.filters[tag].map(el => {
            if (value.name == el.name) {
                el.checked = !value.checked
            }
        })
        setOfferData({ ...tmp })
        let urlParam = []
        tmp.filters[tag].forEach(el => {
            if (el.checked == true) {
                urlParam.push(el.name)
            }
        })
        setToUrl(urlParam, `${tag.substring(0, tag.length - 1)}`)
    }

    const deleteFromDropdown = (value, tag) => {

    }

    const emptyRenderer = () => {
        return <div className={style.empty}>
            <React.Fragment>
                <div className={style.image}>
                    <img src={noVariantEmptyState} />
                </div>
                <p>در حال حاضری پیشنهادی با فیلترهای انتخابی وجود ندارد</p>
                <p className={style.boldText}>.لطفا فیلترهای انتخابی خود را تغییر دهید و یا جهت ثبت درخواست اطلاعات مورد نیاز خود، با واحد پشتیبانی موبیشا در ارتباط باشید</p>
                <Button type="solid"
                    label={"بازگشت به صفحه قبل"}
                    onclick={() => props.history.goBack()}
                />
            </React.Fragment>
        </div>
    }

    if (skeleton) {
        return <Skeleton />
    } else {
        return (<div className={style.wrapper}>
            <Toast tag="checkError" value={toast} text={toast} parentClose={() => setToast('')} />
            <div className={style.header}>
                <h1>لیست پیشنهادات</h1>
            </div>

            <div className={style.searchWrapper}>
                <Searchbar
                    placeholder={"عنوان یا کد کالا یا کد تنوع"}
                    value={getFromUrl("query") ? getFromUrl("query") : ''}
                    searchValue={(value) => searchHandler(value)}
                />
            </div>

            <div className={style.filterWrapper}>
                {urlCheckerForFilters() && <div
                    className={style.deleteAll}
                    onClick={() => deleteAllFiletrs()}
                >
                    <span className={style.icon}>g</span>
                </div>}
                <Dropdown
                    tag='productGroups'
                    label='گروه کالا'
                    placeHolder='گروه کالا'
                    dropdownList={offerData.filters.productGroups}
                    hasCheckbox={true}
                    deleteSelectedItems={deleteFromDropdown}
                    handleSelect={selectHandler}
                    action={getProductList}
                />
                {/* <Dropdown
                    tag='brands'
                    label='برند'
                    placeHolder='برند'
                    dropdownList={offerData.filters.brands}
                    hasCheckbox={true}
                    deleteSelectedItems={deleteFromDropdown}
                    handleSelect={selectHandler}
                    action={getProductList}
                />
                {offerData.type !== 'all-products' && <Dropdown
                    tag='sellers'
                    label='فروشنده'
                    placeHolder='فروشنده'
                    dropdownList={offerData.filters.sellers}
                    hasCheckbox={true}
                    deleteSelectedItems={deleteFromDropdown}
                    handleSelect={selectHandler}
                    action={getProductList}
                />} */}
            </div>

            {offerData.list.length > 0 ? <>
                <div className={style.paginationRow}>
                    <div className={style.pagination}>
                        <div className={style.Dropdown}>
                            <Pagination
                                currentPage={getFromUrl('page') ? getFromUrl('page') : offerData.page}
                                pageCount={offerData.totalPages}
                                setPage={pageSetter}
                            />
                            <TinyDropdown
                                placeholder={getFromUrl('countInPage')}
                                dropdownList={["10", "25", "50", "75", "100"]}
                                selected={selected => {
                                    let page = { ...offerData };
                                    page.countInPage = selected;
                                    setOfferData({ ...page })
                                    setToUrl(selected, 'countInPage')
                                    getProductList()
                                }}
                            />
                            <div className={style.label}>تعداد نمایش در صفحه</div>
                            <div className={style.verticalLine}></div>
                            <div className={style.variantCount}>{toPersianNumber(offerData.productCount) + " محصول "}</div>
                        </div>
                    </div>
                </div>

                <div className={style.listWrapper}>
                    <div className={style.desktopTable}>
                        <div className={style.hiddenListShadow}></div>
                        <div className={style.logListWrapper}>
                            <div
                                className={offset > 480 ? style.listHeaderFixed : style.listHeader}
                                style={offset > 480 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 480 ? { width: 'calc(100% - 280px)' } : null)}
                            >
                                {/* header */}
                                <div className={style.listHeaderItem_name}>مشخصات کالا</div>
                                <div className={style.listHeaderItem175}>گروه کالا</div>
                                <div className={style.listHeaderItem175}>میانگین قیمت<span>(ریال)</span></div>
                                <div className={style.listHeaderItem175}>تعداد رقیب</div>
                                <div className={style.listHeaderItem175}></div>
                                {/* header */}
                            </div>
                            <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                            <div className={style.listWrapper}>
                                {offerData.list ? offerData.list.map((listItem, index) => <div key={`offerData_${index}`}>
                                    <OfferCard
                                        key={index}
                                        data={listItem}
                                    />
                                </div>)
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>

                    <div className={style.paginationTwo}>
                        <Pagination
                            currentPage={getFromUrl('page') ? getFromUrl('page') : offerData.page}
                            pageCount={offerData.totalPages}
                            setPage={pageSetter}
                        />
                    </div>
                    <div className={style.mobilePagination}>
                        <MobilePagination
                            currentPage={getFromUrl('page') ? getFromUrl('page') : offerData.page}
                            pageCount={offerData.totalPages}
                            setPage={pageSetter}
                        />
                    </div>
                </div>
            </>
                :
                <>
                    {emptyRenderer()}
                </>
            }
        </div>)
    }
}
export default withRouter(BlackFridayList)